import React, { useContext } from "react";
import { Button, Grid, Typography } from "@material-ui/core";
import { isEqual, isEmpty } from "lodash";
import { useFormikContext } from "formik";
import DateRangeSelectorFilter from "../../components/date-range-select-filter";
import MultiSelectFilterInput from "../../components/multi-select-filter-input";
import FormModel from "../../domain/model/form-model";
import PageConfig from "../../domain/config";
import { Search as SearchIcon } from "@material-ui/icons";
import CombinedSelectFilterInput from "../../components/combined-select-filter-input";
import PageDomain from "../../domain";
import RadioGroupSelector from "../../components/radio-group-selector";
import { UserListContext } from "../../../../../../context/follow-up-widgets";

const { MODEL_FIELDS } = PageConfig;
const { timeZoneSelectorVisibility } = PageDomain;

const PrimaryFilterSection = () => {
  const { values, setFieldValue, submitForm, handleSubmit } =
    useFormikContext();

  const { results } = useContext(UserListContext);

  let allowedMaxDate = new Date();
  allowedMaxDate.setFullYear(allowedMaxDate.getFullYear() + 1);
  allowedMaxDate = allowedMaxDate.toUTCString();

  return (
    <Grid container direction="column" className="filter-section">
      <Grid container direction="column" className="gap-y-8">
        <Typography variant="subtitle2">Filters</Typography>
        <Grid
          container
          direction="row"
          style={{ backgroundColor: "transparent" }}
        >
          <Grid
            item
            xs={10}
            container
            direction="row"
            className="gap-x-8 gap-y-8"
            style={{ backgroundColor: "transparent" }}
          >
            <DateRangeSelectorFilter
              meta={FormModel[MODEL_FIELDS.adCreatedRange]}
              value={values[MODEL_FIELDS.adCreatedRange]}
              onChange={(nextValue) => {
                const currentValue = values[MODEL_FIELDS.adCreatedRange];
                if (!isEqual(currentValue, nextValue)) {
                  setFieldValue(MODEL_FIELDS.adCreatedRange, nextValue);
                }
              }}
            />
            <DateRangeSelectorFilter
              meta={FormModel[MODEL_FIELDS.adFirstPublishedRange]}
              value={values[MODEL_FIELDS.adFirstPublishedRange]}
              onChange={(nextValue) => {
                const currentValue = values[MODEL_FIELDS.adFirstPublishedRange];
                if (!isEqual(currentValue, nextValue)) {
                  setFieldValue(MODEL_FIELDS.adFirstPublishedRange, nextValue);
                }
              }}
            />
            <DateRangeSelectorFilter
              meta={FormModel[MODEL_FIELDS.adLastPublishedRange]}
              value={values[MODEL_FIELDS.adLastPublishedRange]}
              onChange={(nextValue) => {
                const currentValue = values[MODEL_FIELDS.adLastPublishedRange];
                if (!isEqual(currentValue, nextValue)) {
                  setFieldValue(MODEL_FIELDS.adLastPublishedRange, nextValue);
                }
              }}
            />
            <DateRangeSelectorFilter
              meta={FormModel[MODEL_FIELDS.adExpriedRange]}
              value={values[MODEL_FIELDS.adExpriedRange]}
              onChange={(nextValue) => {
                const currentValue = values[MODEL_FIELDS.adExpriedRange];
                if (!isEqual(currentValue, nextValue)) {
                  setFieldValue(MODEL_FIELDS.adExpriedRange, nextValue);
                }
              }}
            />
            <MultiSelectFilterInput
              meta={FormModel[MODEL_FIELDS.profileStatus]}
              value={values[MODEL_FIELDS.profileStatus]}
              onChange={(nextValue) => {
                const currentValue = values[MODEL_FIELDS.profileStatus];
                if (!isEqual(currentValue, nextValue)) {
                  setFieldValue(MODEL_FIELDS.profileStatus, nextValue);
                }
              }}
            />
            <MultiSelectFilterInput
              meta={FormModel[MODEL_FIELDS.pricingTier]}
              value={values[MODEL_FIELDS.pricingTier]}
              onChange={(nextValue) => {
                const currentValue = values[MODEL_FIELDS.pricingTier];
                if (!isEqual(currentValue, nextValue)) {
                  setFieldValue(MODEL_FIELDS.pricingTier, nextValue);
                }
              }}
            />
            <MultiSelectFilterInput
              meta={FormModel[MODEL_FIELDS.subscriptionStatus]}
              value={values[MODEL_FIELDS.subscriptionStatus]}
              onChange={(nextValue) => {
                const currentValue = values[MODEL_FIELDS.subscriptionStatus];
                if (!isEqual(currentValue, nextValue)) {
                  setFieldValue(MODEL_FIELDS.subscriptionStatus, nextValue);
                }
              }}
            />
            <CombinedSelectFilterInput
              meta={FormModel[MODEL_FIELDS.sortOrder]}
              values={values}
              onChange={({ primaryValue, secondaryValue }) => {
                const sortOrder = PageDomain.sanitizeSortOrder({
                  sortBy: primaryValue,
                  sortDirection: secondaryValue,
                });
                if (
                  !isEqual(values[FormModel.sortOrder.fieldName], sortOrder)
                ) {
                  setFieldValue(FormModel.sortOrder.fieldName, sortOrder);
                }
              }}
            />
            <MultiSelectFilterInput
              meta={FormModel[MODEL_FIELDS.residentCountry]}
              value={values[MODEL_FIELDS.residentCountry]}
              onChange={(nextValue) => {
                const currentValue = values[MODEL_FIELDS.residentCountry];
                if (!isEqual(currentValue, nextValue)) {
                  setFieldValue(MODEL_FIELDS.residentCountry, nextValue);
                }
              }}
            />
          </Grid>
          <Grid
            item
            xs
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="flex-start"
          >
            <Button
              variant="contained"
              className="search-icon"
              startIcon={<SearchIcon />}
              type="submit"
              onClick={() => {
                setFieldValue("pageNumber", 1);
                submitForm();
              }}
            >
              search
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <RadioGroupSelector
        options={FormModel.timeZone.options}
        defaultValue={FormModel.timeZone.defaultValue}
        title={FormModel.timeZone.label}
        value={values[FormModel.timeZone.fieldName]}
        onChange={(e) => {
          const currentValue =
            e?.target.value ?? FormModel.timeZone.defaultValue;
          setFieldValue(FormModel.timeZone.fieldName, currentValue);
          handleSubmit();
        }}
        visibility={timeZoneSelectorVisibility(values) && !isEmpty(results)}
      />
    </Grid>
  );
};

export default PrimaryFilterSection;
